module.exports = __webpack_public_path__ + "img/print.10c4d409.svg";